import React, {useEffect, useState} from 'react';
//import AnnotatorComponent from "../Annotator/AnnotatorComponent";
import ReportAnnotatorComponent from "../Annotator/ReportAnnotatorComponent";

import {hasToken} from "../../Utils/Common";
//import LVComponent from "../Annotator/LVComponent";


function ReportAnnotatorViewComponent(props) {

    hasToken()
    // A re-render is triggered to have updated DOM in order to fix Document.getElementById() access
    const [renderTriggerCounter, setRenderTriggerCounter] = useState('0')



    useEffect(async () => {
        hasToken()
        setRenderTriggerCounter('1')
    }, [renderTriggerCounter])

    return (
        /*<>
            <AnnotatorComponent
                lvComponentShow={true}
                annotationComponentShow={true}
                annotatorFooterShow={false}
                adviceList={[]}
                lvList={props.lvInfo.lvInfo.data}
                annotationData={props.annotationData}
                lvCustomerView={true}
                annotationCustomerView={true}
                suggestComponentShow={false}
                positionCategoryShow={false}
                highlightPossible={false}
                searchComponentShow={false}
                deleteComponentShow={false}
                summaryComponentShow={false}
                saveComponentShow={false}
                publishComponentShow={false}
                editAdviceComponentShow={false}
                ignoreComponentShow={false}
                categoryComponentShow={false}
                createAdviceComponentShow={false}
            />
        </>*/
        <>
            <ReportAnnotatorComponent
                lvreportDisplay={true}
                lvComponentShow={true}
                annotationComponentShow={true}
                annotatorFooterShow={false}
                adviceList={[]}
                lvList={props.lvInfo.lvInfo.data}
                annotationData={props.annotationData}
                lvCustomerView={true}
                annotationCustomerView={true}
                suggestComponentShow={false}
                positionCategoryShow={false}
                highlightPossible={false}
                searchComponentShow={false}
                deleteComponentShow={false}
                summaryComponentShow={false}
                saveComponentShow={false}
                publishComponentShow={false}
                editAdviceComponentShow={false}
                ignoreComponentShow={false}
                categoryComponentShow={false}
                createAdviceComponentShow={false}
            />
        </>
    )
}

export default ReportAnnotatorViewComponent;